import React, { useState } from 'react';
import AccommodationSearchForm from 'Views/AccommodationSearch/components/AccommodationSearchForm';

const API_DATE_FORMAT = 'YYYY-MM-DD';

const AccommodationSearchBlock = () => {
  const [petApproved, setPetApproved] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);
  const [popularDateValue, setPopularDateValue] = useState('default');

  function search(e) {
    e.preventDefault();

    const searchUrl = new URL(drupalSettings.search_url);

    searchUrl.searchParams.append(
      'startDate',
      startDate ? startDate.format(API_DATE_FORMAT) : ''
    );
    searchUrl.searchParams.append(
      'endDate',
      endDate ? endDate.format(API_DATE_FORMAT) : ''
    );
    searchUrl.searchParams.append('adults', adults);
    searchUrl.searchParams.append('children', children);
    searchUrl.searchParams.append('infants', infants);
    searchUrl.searchParams.append(
      'pets',
      petApproved && petApproved == 1 ? 1 : 0
    );
    if (popularDateValue !== 'default') {
      searchUrl.searchParams.append('popularDate', popularDateValue);
    }

    window.open(searchUrl);
  }

  return (
    <div>
      <AccommodationSearchForm
        setPets={setPetApproved}
        petApproved={petApproved}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        adults={adults}
        setAdults={setAdults}
        kids={children}
        setChildren={setChildren}
        infants={infants}
        setInfants={setInfants}
        setPopularDateValue={setPopularDateValue}
        onSubmit={search}
        buttonText={Drupal.t('Search for accommodation')}
        availabilityFound={true}
      />
    </div>
  );
};

export default AccommodationSearchBlock;
